module.exports = __webpack_public_path__ + "img/htu-4-1.8af935e3.png";